module.exports = __webpack_public_path__ + "img/rocket_tank_small.b78f8be1.png";